module.exports = __webpack_public_path__ + "img/symbol_6.c2da930f.png";